import './data-container.css';

export interface DataContainerProps {
  children: React.ReactNode;
}

export const DataContainer = (props: DataContainerProps) => {

  return (
    <div className="data-container">
      <div className="data-container-inside">
        {props.children}
      </div>
    </div>
  );
}

export default DataContainer;
